module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>knowledge</title><path class=\"icon-fill\" d=\"M25,11.11,0,20.56,25,30l25-9.44ZM2.78,22.78v4.69a2.69,2.69,0,0,1,2.22,0V23.61ZM9.44,25.3v8c0,2.33,6.94,5.56,15.56,5.56s15.56-3.23,15.56-5.56v-8L25.4,31a1.1,1.1,0,0,1-.8,0Zm-5.56,3A1.67,1.67,0,1,0,5.56,30a1.67,1.67,0,0,0-1.68-1.7Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/knowledge.svg
// module id = 491
// module chunks = 1